export interface NavigationHistoryState {
  stack: string[];
  index: number;
}

export type NavigationHistoryAction =
  | {type: 'PUSH'; key: string}
  | {type: 'REPLACE'; key: string}
  | {type: 'POP'; key: string};

export function initialNavigationHistoryState(key: string): NavigationHistoryState {
  return {stack: [key], index: 0};
}

/**
 * Mirrors browser history semantics purely from React Router's PUSH/REPLACE/POP
 * navigation types, since no browser API reliably exposes "can go forward" cross-browser.
 * A POP whose key doesn't match either neighbor (e.g. a restored/foreign entry) resets
 * the stack rather than guessing a direction.
 */
export function navigationHistoryReducer(
  state: NavigationHistoryState,
  action: NavigationHistoryAction
): NavigationHistoryState {
  switch (action.type) {
    case 'PUSH': {
      const stack = [...state.stack.slice(0, state.index + 1), action.key];
      return {stack, index: stack.length - 1};
    }
    case 'REPLACE': {
      const stack = [...state.stack];
      stack[state.index] = action.key;
      return {stack, index: state.index};
    }
    case 'POP': {
      if (state.stack[state.index - 1] === action.key) {
        return {stack: state.stack, index: state.index - 1};
      }
      if (state.stack[state.index + 1] === action.key) {
        return {stack: state.stack, index: state.index + 1};
      }
      return initialNavigationHistoryState(action.key);
    }
    default:
      return state;
  }
}
